@if (chartReady() && chartOptions()) {
	<ag-charts [options]="chartOptions()" id="revenueChart"></ag-charts>
}